// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"213":"05fafbe5","450":"e9c05030","660":"a9e363bd","807":"5d129183"}[chunkId] + ".chunk.css";
};